import AgentIcon from "@/shared/assets/png/agent-icon.png";
import "./ai-chat-avatar.scss";

export const AiChatAvatar = () => {
  return (
    <div className="ai-chat-avatar">
      <img
        className="ai-chat-avatar__icon"
        src={AgentIcon}
        alt="ИИ-агент"
      />
    </div>
  );
};

